export enum ErrorCodes {
    FILE_TYPES_INVALID = 'FILE_TYPES_INVALID',
    FILE_SIZE_INVALID = 'FILE_SIZE_INVALID',
    FILE_COUNT_INVALID = 'FILE_COUNT_INVALID',
    FILE_BAD_CONTENT = 'FILE_BAD_CONTENT',
}
